module.exports = __webpack_public_path__ + "static/specificity3-c54d09c54df2b31c838e6ce74ed85c41.png";